import {
  SELECT_QUIZZ,
  SET_ALL_QUIZZES,
  SET_ANSWERS,
  SET_INCOMPLETED_QUIZZES,
  SET_COMPLETED_QUIZZES,
  RESET_QUIZ_DATA,
  DELETE_QUIZ,
  SET_FORWARDED_QUIZZES,
  SET_REPORT_ID_QUIZZ,
  SET_RECOMMENDED_QUIZZES,
  SET_PENDING_RECOMMENDED_QUIZZES,
  SET_IDENTIFIER,
  SET_THREAT_QUIZZES,
  SET_PENDING_THREAT_QUIZZES,
  SET_QUIZZES_BY_CATEGORIE,
  SET_CATEGORIES,
  SET_CATEGORIES_ADD_QUIZZES,
} from "../types/quizzesTypes";

const initialState = {
  all: [],
  selected: null,
  answers: {},
  incompleted_quizzes: [],
  completed_quizzes: [],
  forwarded_quizzes: [],
  recommended_quizzes: [],
  pending_recommended_quizzes: [],
  threat_quizzes: [],
  pending_threat_quizzes: [],
  quizzes_by_categorie:[],
  categories: [],
  categories_add_quizzes: [],
  reportId: "",
  totalPages: 0,
  sources: [],
  level: [],
  associatedUser: [],
  isAllowed: false,
};

const quizzesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_QUIZZES:
      return {
        ...state,
        all: action.payload.items,
        totalPages: action.payload.totalPages,
        sources: action.payload.sources,
        level: action.payload.level,
      };
    case SELECT_QUIZZ:
      return {
        ...state,
        selected: action.payload.item,
        associatedUser: action.payload.associtatedUser,
        isAllowed: action.payload.isAllowed,
      };
    case SET_IDENTIFIER:
      return {
        ...state,
        selected: { ...state.selected, identifier: action.payload },
      };
    case SET_ANSWERS:
      return { ...state, answers: action.payload };
    case SET_INCOMPLETED_QUIZZES:
      return {
        ...state,
        incompleted_quizzes: action.payload.items,
        totalPages: action.payload.totalPages,
        sources: action.payload.sources,
        level: action.payload.level,
      };
    case SET_COMPLETED_QUIZZES:
      return {
        ...state,
        completed_quizzes: action.payload.items,
        totalPages: action.payload.totalPages,
        sources: action.payload.sources,
        level: action.payload.level,
      };
    case SET_RECOMMENDED_QUIZZES:
      return {
        ...state,
        recommended_quizzes: action.payload.items,
        totalPages: action.payload.totalPages,
        sources: action.payload.sources,
        level: action.payload.level,
      };
    case SET_PENDING_RECOMMENDED_QUIZZES:
      return {
        ...state,
        pending_recommended_quizzes: action.payload,
      };
    case SET_FORWARDED_QUIZZES:
      return {
        ...state,
        forwarded_quizzes: action.payload.quizzes,
        totalPages: action.payload.totalPages,
        sources: action.payload.sources,
        level: action.payload.level,
      };
    case DELETE_QUIZ:
      return {
        ...state,
        all: state.all.filter((item) => item._id !== action.payload),
      };
    case RESET_QUIZ_DATA:
      return { ...initialState };
    case SET_REPORT_ID_QUIZZ:
      return { ...state, reportId: action.payload };
    case SET_THREAT_QUIZZES:
      return {
        ...state,
        threat_quizzes: action.payload.items,
        totalPages: action.payload.totalPages,
        sources: action.payload.sources,
        level: action.payload.level,
      };
    case SET_PENDING_THREAT_QUIZZES:
      return {
        ...state,
        pending_threat_quizzes: action.payload,
      };

    case SET_QUIZZES_BY_CATEGORIE:
      return {
        ...state,
        quizzes_by_categorie: action.payload.items,
        // incompleted_quizzes: action.payload.incompleted_items,
        totalPages: action.payload.totalPages,
        sources: action.payload.sources,
        level: action.payload.level,
      };

    case SET_CATEGORIES :
      return {...state,categories: action.payload};

    case SET_CATEGORIES_ADD_QUIZZES :
      return {...state,categories_add_quizzes: action.payload};

    default:
      return state;
  }
};

export default quizzesReducer;
